import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { FaGavel } from "react-icons/fa";
import { GiSparkles } from "react-icons/gi";
import BottomNavigation from "../BottomNavigation";
import Footer from "../Home/Footer";

const Rules = () => {
  const { t } = useTranslation();

  const items = [
    t("RULES_ITEM_1"),
    t("RULES_ITEM_2"),
    t("RULES_ITEM_3"),
    t("RULES_ITEM_4"),
    t("RULES_ITEM_5"),
  ];

  return (
    <>
      <div
        style={{
          overflow: "auto",
          height: "calc(100dvh - 80px)",
          WebkitOverflowScrolling: "touch",
          backgroundImage: `url(${require("../../../assets/img/bg.jpg")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          paddingBottom: "calc(120px + env(safe-area-inset-bottom))",
        }}
        className="bg-secondary-500"
      >
        <Helmet>
          <title>{t("TITLE_RULES")}</title>
        </Helmet>

        <div className="px-4 pt-6 max-w-2xl mx-auto  backdrop-blur-lg">
        
          <div className="rounded-2xl overflow-hidden bg-secondary-700/60 shadow-2xl">
            {/* Hero */}
            <div className="relative bg-gradient-to-br from-secondary-200/40 via-primary-400/40 to-primary-500/40 px-5 py-6 overflow-hidden op">
              <div
                className="absolute inset-0 opacity-30"
                style={{
                  background:
                    "conic-gradient(from 210deg at 25% 30%, transparent, rgba(255,255,255,0.35), transparent 35%)",
                }}
              />
              <div className="absolute -end-8 -top-8 w-40 h-40 rounded-full bg-primary-400/25 blur-3xl" />
              <div className="absolute -start-10 bottom-0 w-32 h-32 rounded-full bg-primary-400/25 blur-3xl" />

              <div className="relative flex items-center gap-3">
                <div className="relative flex-shrink-0">
                  <GiSparkles className="absolute -top-2 -start-2 text-primary-300 text-lg" />
                  <div className="w-14 h-14 rounded-full border-4 border-primary-400 bg-secondary-900/70 shadow-lg flex items-center justify-center">
                    <FaGavel className="text-primary-400 text-xl" />
                  </div>
                </div>
                <div className="min-w-0">
                  <div className="text-white font-extrabold text-xl break-words">
                    {t("RULES_GENERAL_TITLE")}
                  </div>
                  <div className="text-white/60 text-xs mt-0.5 break-words">
                    {t("TITLE_RULES")}
                  </div>
                </div>
              </div>
            </div>

            {/* Details */}
            <div className="px-5 py-5">
              <ol className="space-y-3">
                {items.map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-6 h-6 mt-0.5 rounded-full bg-primary-400/15 border border-primary-400/40 text-primary-400 text-xs font-bold flex items-center justify-center">
                      {i + 1}
                    </span>
                    <span className="text-white/80 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>

        <Footer />
      </div>

      <BottomNavigation isNavVisible={true} />
    </>
  );
};

export default Rules;
